import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["stroke-width"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'star-icon',
    props: {
        strokeWidth: { default: 1.25 }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M7.21246 2.04461C7.54417 1.49164 8.34329 1.49164 8.675 2.04461L10.2857 4.72959C10.4048 4.92824 10.5992 5.06992 10.8244 5.12224L13.8675 5.82929C14.4942 5.97491 14.7412 6.73735 14.3195 7.22472L12.2718 9.59118C12.1203 9.76627 12.046 9.99551 12.066 10.2265L12.3361 13.3485C12.3917 13.9914 11.7452 14.4626 11.1529 14.2109L8.27667 12.9885C8.06386 12.898 7.8236 12.898 7.6108 12.9885L4.73459 14.2109C4.14224 14.4626 3.49575 13.9914 3.55137 13.3485L3.82145 10.2265C3.84143 9.99551 3.76718 9.76627 3.61568 9.59118L1.56801 7.22472C1.1463 6.73735 1.39324 5.97491 2.01996 5.82929L5.06308 5.12224C5.28824 5.06992 5.48262 4.92824 5.60178 4.72959L7.21246 2.04461Z",
                    stroke: "currentColor",
                    "stroke-width": __props.strokeWidth
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
